// extracted by mini-css-extract-plugin
export default {"wrapper":"NoMobile_wrapper__itKa9","bg":"NoMobile_bg__0GDe8","descr":"NoMobile_descr__3bUMv"};